module.exports = __webpack_public_path__ + "static/img/The-Rose.add48ec.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/The-Rose.jpg
// module id = IYX9
// module chunks = 0